/**
 * KAN-752: подписи операторов-кампаний и ошибка "кампания не выбрана".
 */

/** Домен служебных email кампаний: такие адреса пользователю не показываем. */
const SERVICE_EMAIL_SUFFIX = '.smeta.local';

export const OPERATOR_REQUIRED_CODE = 'operator_required';
export const OPERATOR_REQUIRED_TEXT =
  'В кабинете несколько кампаний Telegram-рассылки. Выберите кампанию.';
export const CAMPAIGN_FALLBACK_LABEL = 'Кампания без имени';

export function isServiceEmail(email: string | null | undefined): boolean {
  return (email ?? '').trim().toLowerCase().endsWith(SERVICE_EMAIL_SUFFIX);
}

/** Имя оператора; email только если имени нет и адрес не служебный. */
export function operatorLabel(
  name: string | null | undefined,
  email: string | null | undefined
): string {
  const trimmed = name?.trim();
  if (trimmed) return trimmed;
  if (email && !isServiceEmail(email)) return email;
  return CAMPAIGN_FALLBACK_LABEL;
}

/** Кампанию выбирают явно, только если операторов канала больше одного. */
export function needsOperatorChoice(operators: ReadonlyArray<unknown>): boolean {
  return operators.length > 1;
}

interface ErrorLike {
  response?: { status?: number; data?: unknown };
}

/** Ответ 400 {"code": "operator_required"}: кампания не выбрана. */
export function isOperatorRequiredError(err: unknown): boolean {
  const data = (err as ErrorLike | null)?.response?.data;
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as { code?: unknown }).code === OPERATOR_REQUIRED_CODE
  );
}
